/**
 * Dependency Sharing for Module Federation
 * See: packages/config-apps/src/rspack/shared-deps-config.ts
 *
 * Two mechanisms work together:
 *
 * 1. EXTERNAL CDN DEPENDENCIES (cdnDeps):
 *    Loaded via <script> tags in index.html.ejs, resolved from global scope (eg: window.React)
 *    These are not bundled.
 *
 * 2. SHARED SINGLETONS DEPENDENCIES (sharedSingletonDeps):
 *    Configured as Module Federation singletons with `eager: true`.
 *    IMPORTANT: For eager loading to work, deps MUST be in this entry's dependency graph.
 *    When adding to sharedSingletonDeps, add a matching import below (or ensure
 *    a transitive import pulls it in — e.g. i18next/react-i18next via ./i18n/init).
 *    Note: We cannot iterate over the array because the build does a static analysis.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import 'react/jsx-runtime';
/* eslint-disable-next-line no-restricted-imports */
import '@statsig/react-bindings';
import './i18n/init';
import { App } from './App';

window._isRouterAppLoaded = true;

ReactDOM.render(<App />, document.getElementById('root'));
